var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('aside',{staticClass:"aside-menu"},[_c('b-tabs',[_c('b-tab',[_c('template',{slot:"title"},[_c('i',{staticClass:"icon-bell"})]),_vm._v(" "),_c('div',{staticClass:"p-3"},[_vm._l((_vm.notifications),function(notification){return [_c('notification-item',{key:("item-" + (notification.id)),attrs:{"data":notification}}),_vm._v(" "),_c('hr',{key:("hr-" + (notification.id))})]})],2)],2)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-acc91534","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Aside.vue
// module id = 1177
// module chunks = 0 1